import { Center, Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import {
  useGetPortalSourcingEventQuery,
  useGetPublicBidQuery,
} from "../../../../autogen/bff-api";
import { useApiError } from "../../../../common/errors/useApiError";
import { PortalLayout } from "../components/PortalLayout";
import { EditPublicBidForm } from "./EditPublicBidForm";

export const EditPublicBidPage = () => {
  const { eventId, bidId } = useParams<{ eventId: string; bidId: string }>();
  const displayer = useApiError();

  const bidQuery = useGetPublicBidQuery({ bidId: bidId ?? "" }, { skip: !bidId });
  const eventQuery = useGetPortalSourcingEventQuery({ eventId: eventId ?? "" }, { skip: !eventId });

  if (bidQuery.error) return displayer.show(bidQuery.error);
  if (eventQuery.error) return displayer.show(eventQuery.error);

  if (!eventId || !bidId || !bidQuery.data || !eventQuery.data) {
    return (
      <PortalLayout>
        <Center py="24">
          <Spinner color="smPrimary" />
        </Center>
      </PortalLayout>
    );
  }

  return (
    <EditPublicBidForm eventId={eventId} bidId={bidId} bid={bidQuery.data} event={eventQuery.data} />
  );
};
